import {type Option} from 'web-app/react/components/form-elements/select/types';

/**
 * A shortlist of countries that Famly is growing in intentionally.
 * They should be used as options in a select component when the user wants to select a country for an address.
 */
export enum ShortlistCountry {
    AUSTRIA = 'Austria',
    CANADA = 'Canada',
    DENMARK = 'Denmark',
    GERMANY = 'Germany',
    SWITZERLAND = 'Switzerland',
    UK = 'UK',
    US = 'US',
    IRELAND = 'Ireland',
    SPAIN = 'Spain',
    NORWAY = 'Norway',
    OTHER = 'Other',
}

// A union type of `ShortlistCountry`
export type ShortlistedCountry = `${ShortlistCountry}`;

export const countriesShortlist: Option<ShortlistedCountry>[] = [
    {
        label: 'Austria',
        value: 'Austria',
    },
    {
        label: 'Canada',
        value: 'Canada',
    },
    {
        label: 'Denmark',
        value: 'Denmark',
    },
    {
        label: 'Germany',
        value: 'Germany',
    },
    {
        label: 'Switzerland',
        value: 'Switzerland',
    },
    {
        label: 'United Kingdom',
        value: 'UK',
    },
    {
        label: 'United States of America',
        value: 'US',
    },
    {
        label: 'Ireland',
        value: 'Ireland',
    },
    {
        label: 'Spain',
        value: 'Spain',
    },
    {
        label: 'Norway',
        value: 'Norway',
    },
    {
        label: 'Other',
        value: 'Other',
    },
];
